module.exports = __webpack_public_path__ + "static/media/profile.055a9197.png";